import React from 'react';
import { Form, OverlayTrigger, Tooltip} from 'react-bootstrap';

const ToggleSwitch = ({ onToggle, isToggleOn, isRTL, t }) => {
    const isDarkMode = document.body.classList.contains('d-mode');

    const containerStyle = {
        padding: '0 5px 2px 5px',
        transform: isRTL === 'rtl' ? 'scaleX(-1)' : 'scaleX(1)',
    };
    return (
        <div className="toggle-switch-container" style={containerStyle}>
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{t('NORMALIZED_CALCULATION')}</Tooltip>}
            >
                <Form.Check
                    type="switch"
                    id="custom-switch"
                    // label={isToggled ? "Show" : "Hide"}
                    checked={isToggleOn}
                    onChange={e => onToggle(e.target.checked)}
                    style={isDarkMode ? { filter: (!isToggleOn ? 'invert(1) brightness(1)' : 'invert(1) brightness(1.3)') } : {}}
                // reverse={isRTL === 'rtl'}
                />
            </OverlayTrigger>
            <style>{`
                .toggle-switch-container .form-check-input[type="checkbox"]:focus {
                    box-shadow: none;
                }
                .toggle-switch-container .form-check-input[type="checkbox"] {
                    ${isDarkMode ? 'background-color: #fff !important;' : ''}
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='${!isToggleOn ? (isDarkMode ? '%23D3366F' : '%23323233') : (isDarkMode ? '%23D3366F' : '%239B4EDF')}'/%3e%3c/svg%3e") !important;
                    background-color: #e0e0e0 !important;
                }
            `}</style>
        </div>
    );
};

export default ToggleSwitch;
